import React, { useEffect, useState, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUserContext } from "../../context/DealerProfile";
import SendEmailFormatSecond from '../../components/SendMailFormatSecond'
import PaginatedList from "../PaginationList";
import useSWR, { mutate } from "swr";
import { Plus } from "lucide-react";
import merge from "lodash.merge"; // add this at top
// import { AllStates } from "../context/globalState.jsx";
import { AllStates } from "../../context/globalState.jsx";


const OrderDetail = ({ expanded }) => {
  const { dealerDetail } = useUserContext();
  const { allState, allStatedispatch } = useContext(AllStates);
  // const [lead, setLead] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const { id } = useParams();

  const idToFetch = id;
  const [showModal, setShowModal] = useState(false);
  // const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const module = "Contacts";
  const [selectedRelatedList, setSelectedRelatedList] = useState(null);
  const [calls, setCalls] = useState([])

  const [selectedTransition, setSelectedTransition] = useState(null); // Or appropriate default
  const [widgetValues, setWidgetValues] = useState({}); // Store widget values
  const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
  // Fetcher for full contact details
  const fetcher = (url) => fetch(url).then((res) => res.json());

  const url = idToFetch
    ? `/server/dealer_backend/getSpecificContact?id=${idToFetch}`
    : null;

  const {
    data,
    isLoading,
    mutate: mutateContact
  } = useSWR(url, fetcher, {
    revalidateOnFocus: false, // prevents refetch on tab focus or clicks
  });

  // Fetcher for lighter record fields
  const fetcher2 = (url) => fetch(url).then((res) => res.json());

  // Disabled by default — will fetch only when manually triggered
  const {
    data: data2,
    mutate: mutateContact2
  } = useSWR(
    null, // no auto-fetch
    fetcher2
  );





  // data structure assumed from your current fetch:
  // data.status, data.data (array)
  let lead = null;
  if (data && data.status === "success") {
    // If needed, find the exact lead from data.data by id, though your URL already filters by id
    lead = data.data?.find((item) => item.id === idToFetch) || data.data?.[0];
  }

  const [alternatePhone, setAlternatePhone] = useState(lead?.Alternate_Mobile || "");
  const [callRemarks, setCallRemarks] = useState("");
  const [donorInterest, setDonorInterest] = useState(lead?.Purpose1);
  const [callStatus, setCallStatus] = useState(lead?.Call_Status);
  const [donorName, setDonorName] = useState("");
  const [email, setEmail] = useState(lead?.Email || "");
  const [phone, setPhone] = useState(lead?.Mobile_No || "");
  const [alternatePhoneError, setAlternatePhoneError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactPreference, setContactPreference] = useState("Call");

  const [contactPreferenceError, setContactPreferenceError] = useState("");




  const [rescheduleDateTime, setRescheduleDateTime] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);

  const totalPages = Math.ceil(calls.length / recordsPerPage);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentCalls = calls.slice(indexOfFirstRecord, indexOfLastRecord);



  const notesRef = useRef(null);






  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`/server/dealer_backend/getSpecificContact?id=${idToFetch}`); // Replace with actual backend URL
  //       const data = await response.json();
  //       // console.log(data);

  //       if (data.status === "success") {
  //         const filteredLead = data.data.find((item) => item.id === idToFetch);
  //         setLead(data.data[0]);
  //       } else {
  //         console.error("Error fetching data:", data.error);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch lead data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchLeadData();
  // }, []);






  const [notesData, setNotesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [sponsorData, setSponsorData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [emails, setEmails] = useState([]);
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState(false);
  const [donationPurpose, setDonationPurpose] = useState("");
  const [donationOptions, setDonationOptions] = useState([]);
  const [contactPreferencesOptions, setContactPreferencesOptions] = useState([]);
  const [callDispositionOptions, setCallDispositionOptions] = useState([]);

  // const [callRemarks, setCallRemarks] = useState("");

  const fetchPicklistOptions = async (fieldId, setOptions) => {
    try {
      const res = await fetch(
        `/server/dealer_backend/getPickListValues/${fieldId}?module=Contacts&type=used`
      );
      const result = await res.json();
      if (result.status === "success") {
        // console.log({ fieldId, result });
        setOptions(result.data || []);
        const key = `picklist-${fieldId}`
        allStatedispatch({
          type: "add",
          payload: { [key]: result?.data },
        })

      } else {
        console.error("Failed to fetch picklist:", result.error);
      }
    } catch (err) {
      console.error("Error fetching picklist:", err);
    }
  };

  useEffect(() => {

    const picklistMap = [
      { key: 'picklist-760958000001085586', action: () => fetchPicklistOptions("760958000001085586", setDonationOptions), onData: setDonationOptions },
      { key: 'picklist-760958000004566661', action: () => fetchPicklistOptions("760958000004566661", setContactPreferencesOptions), onData: setContactPreferencesOptions },
      { key: 'picklist-760958000004425144', action: () => fetchPicklistOptions("760958000004425144", setCallDispositionOptions), onData: setCallDispositionOptions },
    ]

    // if(!allState['picklist-760958000001085586']){
    //     fetchPicklistOptions("760958000001085586", setDonationOptions);        // Donation Purpose
    // }else{
    //     setDonationOptions(allState['picklist-760958000001085586'])
    // }
    // if(!allState['picklist-760958000004566661']){
    //     fetchPicklistOptions("760958000004566661", setContactPreferencesOptions); // Contact Preferences
    // }
    // if(!allState['picklist-760958000004425144']){
    //     fetchPicklistOptions("760958000004425144", setCallDispositionOptions);   // Call Dispositions
    // }

    picklistMap.forEach(ob => {
      if (!allState[ob?.key]) {
        // console.log("fetching : ", ob.key)
        ob.action();
      } else {
        ob.onData(allState[ob?.key]);
      }
    })

    // console.log("---- PICKLIST ----")
    // console.log(allState['picklist-760958000001085586'])
    // console.log(allState['picklist-760958000004566661'])
    // console.log(allState['picklist-760958000004425144'])
    // console.log(allState)
    // fetchPicklistOptions("760958000000407488", setLeadSourceOptions); // IFR Lead Source
  }, []);





  const fetchNotes = async () => {
    try {
      const res = await fetch(`/server/dealer_backend/getNotes?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      if (json.status === "success") {
        const sortedNotes = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        setNotesData(sortedNotes);
      } else {
        console.error("Error fetching notes:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };

  const fetchSponsorChild = async () => {
    try {
      const res = await fetch(`/server/dealer_backend/getSponsorChild?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      if (json.status === "success") {
        const sortedSponsorChild = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        setSponsorData(sortedSponsorChild);
      } else {
        console.error("Error fetching sponsor child data:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchAttachments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getAttachments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();



      if (json.status === "success") {
        const sortedAttachments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setAttachments(sortedAttachments);

      } else {
        console.error("Error fetching attachments:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchStatus = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getStatus?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)

      if (json.status === "success") {
        const sortedStatus = json.data.sort((a, b) => new Date(b.Modified_Time) - new Date(a.Modified_Time));
        setStatusData(sortedStatus);

      } else {
        console.error("Error fetching status:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchEmails = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getEmails?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedEmails = json.data.sort((a, b) => new Date(b.time) - new Date(a.time));
        setEmails(sortedEmails);

      } else {
        console.error("Error fetching emails:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchPayments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getPayments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedPayments = json.data.sort((a, b) => new Date(b.Transaction_Date) - new Date(a.Transaction_Date));

        setPayments(sortedPayments);

      } else {
        console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchManualCalls = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getManualCalls?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedCalls = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setCalls(sortedCalls);

      } else {
        console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };
  useEffect(() => {
    fetchNotes();
    fetchStatus();
    fetchAttachments();
    fetchEmails();
    fetchPayments();
    fetchManualCalls();
    fetchSponsorChild();

  }, [idToFetch])

  const formatDateForBackend = (dateInput) => {
    if (!dateInput) return "";

    const date = new Date(dateInput);

    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const offset = -date.getTimezoneOffset(); // Note the sign flip
    const sign = offset >= 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const offsetHours = pad(Math.floor(absOffset / 60));
    const offsetMinutes = pad(absOffset % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
  };





  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [remarksError, setRemarksError] = useState("");

  const handleSubmit = async () => {
    setEmailError("");
    setPhoneError("");
    setAlternatePhoneError("");
    setError(false);
    setIsSubmitting(true);

    // --- Validation ---
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    let isValid = true;

    if (email && !emailRegex.test(email)) {
      const msg = "Please enter a valid email address.";
      setEmailError(msg);
      toast.error(msg);
      isValid = false;
    }

    if (phone && !phoneRegex.test(phone)) {
      const msg = "Phone must be a 10-digit number.";
      setPhoneError(msg);
      toast.error(msg);
      isValid = false;
    }

    // if (alternatePhone && !phoneRegex.test(alternatePhone)) {
    //   const msg = "Alternate phone must be a 10-digit number.";
    //   setAlternatePhoneError(msg);
    //   toast.error(msg);
    //   isValid = false;
    // }

    if (!callStatus) {
      setError(true);
      isValid = false;
    }

    if (callStatus === "Call back" && !rescheduleDateTime) {
      isValid = false;
    }

    if (callStatus === "Hot lead" && !rescheduleDateTime) {
      isValid = false;
    }
    if (!callRemarks || callRemarks.trim() === "") {
      const msg = "Remarks are required.";
      setRemarksError(msg);
      isValid = false;
    }


    if (!isValid) {
      setIsSubmitting(false);
      return false;
    }

    // --- Prepare payloads ---


    const callPayload = {
      data: [
        {
          Related_Record_of_Donor: {
            id: lead?.id,
            name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
          },
          Name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
          Email: lead?.Email || email,
          Mobile_Number: lead?.Mobile || phone,
          Alternate_Mobile: alternatePhone,
          Remarks: callRemarks,
          Donor_Interest: donorInterest,
          Call_Status: callStatus,
          Call_Type: "outbound",
          Contact_Preferences: contactPreference,
          Phone_2: alternatePhone,
          Purpose1: donationPurpose,
          Reschedule_Time:
            (callStatus === "Call back" || callStatus === "Hot lead") && rescheduleDateTime
              ? formatDateForBackend(rescheduleDateTime)
              : null,

          Catalyst_User: lead?.Catalyst_User ? lead?.Catalyst_User.id : null,

          // Catalyst_User_Email: selectedCatalystUser?.Email || "",
          Catalyst_User_Email: lead?.Catalyst_User_Email || "",
        },
      ],
    };

    const leadUpdatePayload = {
      data: [
        {
          Contact_Preferences: contactPreference,
          Phone_2: alternatePhone,
          Remarks: callRemarks,
          // Purpose1: donationPurpose,
          Call_Status: callStatus,
        },
      ],
    };

    try {
      // --- Run API calls in parallel ---
      const [leadUpdateRes, callRes] = await Promise.all([
        fetch(`/server/dealer_backend/edit-contactDetails/${lead?.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(leadUpdatePayload),
        }),
        fetch("/server/dealer_backend/handleCalls", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(callPayload),
        }),
      ]);

      const [leadUpdateResult, callResult] = await Promise.all([
        leadUpdateRes.json(),
        callRes.json(),
      ]);

      if (!leadUpdateRes.ok || leadUpdateResult.status !== "success") {
        toast.error("Failed to update donor fields.");
        return false;
      }

      if (!callRes.ok || callResult.status !== "success") {
        toast.error("Failed to create call log.");
        return false;
      }



      // Optimistic update in UI before lighter API finishes
      // Fetch and merge new lighter fields safely
      if (idToFetch) {
        fetcher2(`/server/dealer_backend/getSpecificRecordFields?id=${idToFetch}`)
          .then((lighterData) => {
            mutateContact((prev) => {
              if (!prev) return lighterData; // no existing data, just return new
              return merge({}, prev, lighterData); // deep merge keeps old fields
            }, false);
          })
          .catch((err) => console.error("Error fetching lighter fields:", err));
      }

      await fetchManualCalls();

      // ✅ Show success modal
      setShowSuccessModal(true);

      // Auto-hide after 3 seconds
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 3000);

      return true;
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An unexpected error occurred.");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };











  const LeadField = ({ label, value, icon }) => (
    <div className="form-group-field2">
      <label>{label}</label>
      <span>
        {icon && <span className="icon">{icon}</span>}
        {value || "—"}
      </span>
    </div>
  );



  const formatSize = (bytes) => {
    if (!bytes) return "—";
    const kb = bytes / 1024;
    return kb < 1024
      ? `${kb.toFixed(1)} KB`
      : `${(kb / 1024).toFixed(2)} MB`;
  };




  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };



  const [relatedLists, setRelatedLists] = useState([]);

  // useEffect(() => {
  //   const fetchRelatedLists = async () => {

  //     try {
  //       const response = await fetch(`/server/dealer_backend/getRelatedLists?module=${module}`);
  //       const data = await response.json();
  //       // console.log(data);

  //       if (data.status === "success") {
  //         setRelatedLists(data.related_lists);
  //       } else {
  //         console.error("Failed to fetch transitions:", data.message);
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch related lists:", err);
  //     }
  //   };

  //   fetchRelatedLists();
  // }, [module]);

  const fetcher3 = (url) => fetch(url).then((res) => res.json());

  // useMemo ensures the URL is stable and only changes when `module` changes
  const url3 = useMemo(
    () => (module ? `/server/dealer_backend/getRelatedLists?module=${module}` : null),
    [module]
  );

  const { data: data3 } = useSWR(url3, fetcher3, {
    revalidateOnFocus: false, // prevent refetch on tab focus/clicks
  });

  // Update state only when data is successfully fetched
  useEffect(() => {
    if (data3?.status === "success") {
      const filteredLists = data3.related_lists.filter(
        (list) => list.name !== "Donor" &&  list.name !== "Voice of the Customer"
      );
      setRelatedLists(filteredLists);
    }
  }, [data3]);



  useEffect(() => {
    if (lead?.Mobile) {
      setPhone(lead.Mobile);
    }
  }, [lead]);


  const vari = `${lead?.First_Name || ''} ${lead?.Last_Name || ''}`.trim();



  useEffect(() => {
    if (isWidgetModalOpen && lead) {
      setEmail(lead.Email || "");
      setPhone(lead.Mobile_No || "");
      setAlternatePhone(lead.Phone_2 || "");
      setCallRemarks("");
      setDonationPurpose(lead.Purpose1 || "");
      setContactPreference(lead.Contact_Preferences || "");
      setCallStatus(lead.Call_Status || "");
      // setRescheduleDateTime(...) if needed
    }
  }, [isWidgetModalOpen, lead]);


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [hoveredCol, setHoveredCol] = useState(null);

  const sortedCalls = React.useMemo(() => {
    let sortableItems = [...calls];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (["Created_Time", "Reschedule_Time"].includes(sortConfig.key)) {
          const dateA = a[sortConfig.key] ? new Date(a[sortConfig.key]) : 0;
          const dateB = b[sortConfig.key] ? new Date(b[sortConfig.key]) : 0;
          return sortConfig.direction === "asc"
            ? dateA - dateB
            : dateB - dateA;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [calls, sortConfig]);



  function parseCustomDate(dateStr) {
    if (!dateStr) return null;
    // Try native Date parsing first for ISO strings
    const native = new Date(dateStr);
    if (!isNaN(native)) return native;

    // Fallback for formats like DD/MM/YYYY or DD/MM/YYYY HH:mm
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour = 0, minute = 0] = (timePart || "").split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute);
  }

  const [paymentSortConfig, setPaymentSortConfig] = useState({
    key: null,
    direction: "asc"
  });

  const [paymentHoveredCol, setPaymentHoveredCol] = useState(null);


  // const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };


  const requestPaymentSort = (key) => {
    let direction = "asc";
    if (paymentSortConfig.key === key && paymentSortConfig.direction === "asc") {
      direction = "desc";
    }
    setPaymentSortConfig({ key, direction });
  };

  const sortedPayments = useMemo(() => {
    let sortableItems = [...payments];
    if (paymentSortConfig.key) {
      sortableItems.sort((a, b) => {
        let dateA = parseCustomDate(a[paymentSortConfig.key]);
        let dateB = parseCustomDate(b[paymentSortConfig.key]);
        if (!dateA || !dateB) return 0;
        return paymentSortConfig.direction === "asc"
          ? dateA - dateB
          : dateB - dateA;
      });
    }
    return sortableItems;
  }, [payments, paymentSortConfig]);

  const [emailSortConfig, setEmailSortConfig] = useState({ key: null, direction: "asc" });
  const [emailHoveredCol, setEmailHoveredCol] = useState(null);


  const sortedEmails = React.useMemo(() => {
    let sortableItems = [...emails];
    if (emailSortConfig.key) {
      sortableItems.sort((a, b) => {
        if (emailSortConfig.key === "time") {
          const dateA = a.time ? new Date(a.time) : 0;
          const dateB = b.time ? new Date(b.time) : 0;
          return emailSortConfig.direction === "asc"
            ? dateA - dateB
            : dateB - dateA;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [emails, emailSortConfig]);


  const requestEmailSort = (key) => {
    let direction = "asc";
    if (emailSortConfig.key === key && emailSortConfig.direction === "asc") {
      direction = "desc";
    }
    setEmailSortConfig({ key, direction });
  };




  return (

    isLoading ? (
      <div className="flex justify-center items-center h-screen">

        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    ) : (
      <React.Fragment>
        <header
          style={{
            position: 'fixed',
            top: 0,
            left: expanded ? '5rem' : '16rem',
            right: 0,
            height: '5rem',
            backgroundColor: 'white',
            zIndex: 1000,
            borderBottom: '1px solid #e5e7eb',
          }}
          className="header-fixed mobile-header bg-white border-b flex items-center justify-between px-6 py-4"
        >
          {/* LEFT: Back, avatar, name */}
          <div className="flex items-center gap-4 min-w-0">
            <button
              className="text-gray-600 hover:text-black text-lg"
              onClick={() => navigate('/existing-donor')}  // Go back one step in browser history
              aria-label="Go back"
            >
              <ArrowLeft />
            </button>


            <div className="w-10 h-10 rounded-full bg-[#14446D] flex items-center justify-center text-white font-semibold text-lg">
              {vari?.charAt(0).toUpperCase()}
            </div>
            <h1 className="text-xl font-semibold text-[#14446D] truncate">
              {`${lead?.First_Name || ''} ${lead?.Last_Name || ''}`.trim()}
            </h1>
          </div>

          {/* RIGHT: Buttons */}
          <div className="flex items-center gap-3">
            <button
              className="
        px-5 py-2
        bg-[#14446D] text-white
        rounded-lg
        hover:bg-[#0e3250]
        transition
        font-semibold
        focus:outline-none focus:ring-2 focus:ring-[#14446D88]
        active:scale-95
        shadow
        text-base
      "
              onClick={() => setShowModal(true)}
            >
              Send Email
            </button>
            {/* Desktop Log Button */}
            <button
              onClick={() => setIsWidgetModalOpen(true)}
              className="
        hidden md:inline-block
        px-4 py-2
        border border-[#14446D]
        text-[#14446D]
        rounded-lg
        hover:bg-[#f6fafd]
        hover:text-[#0e3250]
        focus:outline-none focus:ring-2 focus:ring-[#14446D44]
        transition
        font-semibold
        text-base
      "
            >
              Create Log
            </button>
            {/* Mobile Log Button */}
            <button
              onClick={() => setIsWidgetModalOpen(true)}
              className="
        md:hidden
        px-4 py-2
        border border-[#14446D]
        text-[#14446D]
        rounded-lg
        hover:bg-[#f6fafd]
        hover:text-[#0e3250]
        focus:outline-none focus:ring-2 focus:ring-[#14446D44]
        transition
        font-semibold
        text-base
      "
            >
              Create Log
            </button>
          </div>
        </header>


        <div className="flex">


          <aside
            style={{
              position: "fixed",
              top: "4rem",
              left: "16rem",
              bottom: 0,
              backgroundColor: "white",
              padding: "1rem",
              borderRight: "1px solid #e5e7eb",
              overflowY: "auto",
              overflowX: "auto",
            }}
            className="related-list header-fixed w-64 bg-white border-r p-4 min-h-screen"
          >
            <h3 className="text-lg font-semibold mb-4">Related List</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              {relatedLists.map((item, idx) => (
                <li
                  key={item.id || idx}
                  onClick={() => {
                    setSelectedRelatedList(item.name);
                    if (item.name === "Notes") {
                      window.location.hash = "#notes";
                    } else if (item.name === "Lead Status History") {
                      window.location.hash = "#status";
                    } else if (item.name === "Attachments") {
                      window.location.hash = "#attach";
                    } else if (item.name === "Emails") {
                      window.location.hash = "#email";
                    } else if (item.name === "Manual Calls") {
                      window.location.hash = "#call";
                    } else if (item.name === "Payments") {
                      window.location.hash = "#payment";
                    } else if (item.name === "Donor Profiling") {
                      window.location.hash = "#profiling";
                    } else if (item.name === "SponsorChild") {
                      window.location.hash = "#sponsor-child";
                    }
                  }}
                  className={`group flex justify-between items-center hover:bg-gray-100 px-2 py-1 rounded cursor-pointer ${selectedRelatedList === item.name ? "bg-gray-100 font-medium" : ""
                    }`}
                >
                  <span className="flex items-center gap-1">
                    {item.display_label || item.name}

                    {/* Count badges */}
                    {item.name === "Notes" && notesData.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {notesData.length}
                      </span>
                    )}
                    {item.name === "Attachments" && attachments.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {attachments.length}
                      </span>
                    )}
                    {item.name === "Emails" && emails.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {emails.length}
                      </span>
                    )}
                    {item.name === "Manual Calls" && calls.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {calls.length}
                      </span>
                    )}
                    {item.name === "Payments" && payments.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {payments.length}
                      </span>
                    )}
                    {item.name === "Donor Profiling" && statusData.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {statusData.length}
                      </span>
                    )}
                    {item.name === "SponsorChild" && sponsorData.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {sponsorData.length}
                      </span>
                    )}
                  </span>

                  {/* Plus icon on right side, only for Donor Profiling & visible on hover */}
                  {item.name === "Donor Profiling" && (
                    <Plus
                      size={16}
                      className="text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/edit-contact-details/${idToFetch}`, { state: { lead } });
                      }}

                    />
                  )}
                </li>
              ))}
            </ul>
          </aside>


          <main style={{
            // marginTop: '4rem',
            // marginLeft: '14rem',
            // height: 'calc(100vh - 4rem)',
            // overflowY: 'auto',
            padding: '1rem',

          }}>
            <div className="lead-maindiv contact-div lead-container p-4 flex-1">
              {/* Lead Status Card */}


              {isWidgetModalOpen && (
                <div className="modal-overlay fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999] px-2 sm:px-0">
                  <div className="modal-content bg-white rounded-lg p-4 sm:p-8 w-full max-w-md sm:max-w-4xl shadow-lg overflow-y-auto max-h-[90vh]">
                    <h2 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6">Create Call Log</h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-sm sm:text-base">
                      <div>
                        <label className="block text-gray-700 mb-1">Donor Name</label>
                        <input type="text" value={`${lead?.First_Name || ""} ${lead?.Last_Name || ""}`}
                          readOnly className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2" />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-gray-700 mb-1 font-medium">
                          Email
                        </label>
                        <input
                          id="email"
                          type="email"
                          value={email || lead?.Email || ""}
                          onChange={(e) => setEmail(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                          aria-invalid={!!emailError}
                          aria-describedby="email-error"
                        />
                        {emailError && (
                          <p id="email-error" className="text-red-600 text-xs mt-1">
                            {emailError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-gray-700 mb-1">Phone</label>
                        <input
                          type="text"
                          value={lead?.Mobile_No !== undefined && lead?.Mobile_No !== null && lead?.Mobile_No !== "" ? lead.Mobile_No : phone}
                          onChange={(e) => setPhone(e.target.value)}
                          readOnly={!!lead?.Mobile_No}
                          className={`w-full ${lead?.Mobile_No ? 'bg-gray-100' : 'bg-white'} border border-gray-300 rounded-md px-3 py-2`}
                        />
                        {phoneError && <p className="text-red-500 text-xs mt-1">{phoneError}</p>}
                      </div>



                      <div>
                        <label className="block text-gray-700 mb-1">Alternate Phone</label>
                        <input
                          type="text"
                          value={lead?.Phone_2 !== undefined && lead?.Phone_2 !== null && lead?.Phone_2 !== "" ? lead.Phone_2 : alternatePhone}
                          onChange={(e) => setAlternatePhone(e.target.value)}
                          // readOnly={!!lead?.Phone_2}
                          className={`w-full ${lead?.Phone_2 ? 'bg-gray-100' : 'bg-white'} border border-gray-300 rounded-md px-3 py-2`}
                        />
                        {/* {alternatePhoneError && <p className="text-red-500 text-xs mt-1">{alternatePhoneError}</p>} */}
                      </div>
                      <div className="md:col-span-1">
                        <label className="block text-gray-700 mb-1">
                          Call Remarks <span className="text-red-500">*</span>
                        </label>
                        <textarea
                          rows="3"
                          value={callRemarks}
                          onChange={(e) => setCallRemarks(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        />
                        {remarksError && (
                          <p className="text-red-500 text-sm mt-1">{remarksError}</p>
                        )}
                      </div>

                      {/* <div>
                      <label className="block text-gray-700 mb-1">Donor Interest</label>
                      <select value={donorInterest} onChange={(e) => setDonorInterest(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2">
                        <option value="">-- Select --</option>
                        <option value="One Time Donation">One Time Donation</option>
                        <option value="Monthly Donation">Monthly Donation</option>
                        <option value="Volunteering">Volunteering</option>
                        <option value="Corporate Partnership">Corporate Partnership</option>
                      </select>
                    </div> */}

                      <div>
                        <label className="block text-gray-700 mb-1">
                          Contact Preferences
                        </label>
                        <select
                          value={contactPreference}
                          onChange={(e) => setContactPreference(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        >

                          {contactPreferencesOptions.map((option, idx) => (
                            <option key={idx} value={option}>{option}</option>
                          ))}
                        </select>
                        {error && !contactPreference && (
                          <p className="text-red-500 text-sm mt-1">Contact Preference is required.</p>
                        )}
                      </div>


                      <div>
                        <label className="block text-gray-700 mb-1">Donor Interest  <span className="text-red-600">*</span></label>
                        <select
                          value={donationPurpose}
                          onChange={(e) => setDonationPurpose(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        >
                          <option value="">Select Interest</option>
                          {donationOptions.map((option, idx) => (
                            <option key={idx} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>



                      <div>
                        <label className="block text-gray-700 mb-1">
                          Call Dispositions <span className="text-red-500">*</span>
                        </label>
                        <select
                          value={callStatus}
                          onChange={(e) => setCallStatus(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        >

                          {callDispositionOptions.map((option, idx) => (
                            <option key={idx} value={option}>{option}</option>
                          ))}
                        </select>
                        {error && !callStatus && (
                          <p className="text-red-500 text-sm mt-1">Call Disposition is required.</p>
                        )}
                      </div>





                      {callStatus === "Call back" && (
                        <div>
                          <label className="block text-gray-700 mb-1">Reschedule Date & Time  <span className="text-red-500 ml-1">*</span></label>
                          <input
                            type="datetime-local"
                            value={rescheduleDateTime}
                            onChange={(e) => setRescheduleDateTime(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2"
                          />
                        </div>
                      )}

                      {callStatus === "Hot lead" && (
                        <div>
                          <label className="block text-gray-700 mb-1">Reschedule Date & Time  <span className="text-red-500 ml-1">*</span></label>
                          <input
                            type="datetime-local"
                            value={rescheduleDateTime}
                            onChange={(e) => setRescheduleDateTime(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2"
                          />
                        </div>
                      )}

                    </div>
                    <div className="flex justify-end space-x-4 mt-8">
                      <button className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600" onClick={() => setIsWidgetModalOpen(false)}>Cancel</button>
                      <button
                        className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 disabled:bg-green-300 disabled:cursor-not-allowed"
                        onClick={async () => {
                          if (isSubmitting) return; // Prevent double click
                          const result = await handleSubmit();
                          if (result) {
                            setIsWidgetModalOpen(false);
                          } else {
                            setIsSubmitting(false); // Re-enable on failure
                          }
                        }}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>


                    </div>
                  </div>
                </div>
              )}








              {/* Lead Information Card */}
              <div className="contact-profile lead-profile-container">

                {lead ? (
                  <div className="lead-cards">
                    {/* Left Card */}
                    <div className="lead-card">
                      {/* <button
                        type="button"
                        aria-label="Edit"
                        className="mt-[-12px] mr-[20px] absolute top-4 right-4 bg-[#2070B9] text-white px-3 py-1 rounded-full shadow-md flex items-center transition hover:bg-sky-600"
                        onClick={() => navigate(`/edit-contact-details/${idToFetch}`)} // add your handler here if needed
                      >
                        {/* <span className="block md:hidden">
                          {/* Simple Pencil SVG Icon */}
                      {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828A2 2 0 019 17H7v-2a2 2 0 012-2z" />
                          </svg>
                        </span> */}
                      {/* <span className="hidden md:block">Edit</span> */}
                      {/* </button> */}
                      <div className="form-group-field">
                        <label className="dropdown-label">Contact Preferences</label>
                        <span
                          className={`inline-block w-fit px-3 py-1 rounded-full text-sm font-medium ${lead.Contact_Preferences === "Do Not Disturb"
                            ? "bg-red-500 !text-white"
                            : lead.Contact_Preferences === "Call"
                              ? "bg-yellow-500 text-black"
                              : lead.Contact_Preferences === "WhatsApp"
                                ? "bg-green-500 !text-white"
                                : lead.Contact_Preferences === "Email"
                                  ? "bg-sky-500 !text-white"
                                  : "bg-gray-300 text-black"
                            }`}
                        >
                          {lead.Contact_Preferences || "—"}
                        </span>
                      </div>


                      <div className="form-group-field">
                        <label className="dropdown-label">Email</label>
                        <span className="email-value">{lead?.Email || "—"}</span>
                      </div>


                      <div className="form-group-field">
                        <label>Mobile No.</label>
                        <span>
                          <FaPhoneAlt className="phone-icon" />
                          {lead.Mobile_No || "—"}
                        </span>
                      </div>

                      {/* <div className="form-group-field">
                        <label>Last Donation Date</label>
                        <span className="email-link">{lead.Last_Donation_Date || "—"}</span>
                      </div> */}


                      {/* <div className="form-group-field">
                        <label>Last Donation Amount</label>
                        <span className="email-link">{lead.Last_Donation_Amount ? `₹${lead.Last_Donation_Amount}` : "—"}</span>
                      </div> */}
                      {/* <div className="form-group-field">
                        <label>Expected Donation Amount</label>
                        <span className="email-link">{lead.Expected_Donation_Amount ? `₹${lead.Expected_Donation_Amount}` : "—"}</span>
                      </div> */}

                    </div>

                    {/* Right Card */}

                  </div>
                ) : (
                  <p className="loading-text">Loading contact details...</p>
                )}
              </div>


              <div className="lead-container2">
                <h3 className="lead-title">Contact Information</h3>
                <hr className="lead-divider" />
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    {/* Left Column */}
                    <div className="space-y-3">
                      <LeadField label="Organization Name" value={lead?.Organization_Name || "—"} />
                      <LeadField label="Parent Donor ID" value={lead?.Parent_Donor_ID || "—"} />
                      <LeadField label="Secondary Email" value={<span>{lead?.Secondary_Email || "—"}</span>} />
                      <LeadField label="Alternate Mobile No." value={lead?.Phone_2 || "—"} />
                      <LeadField label="Date of Birth" value={lead?.Date_of_Birth || "—"} />
                      <LeadField label="Potential Type" value={lead?.Potential_Type || "—"} />
                      <LeadField label="Donation Type" value={lead?.Donation_Type || "—"} />
                      <LeadField label="Parent Contact" value={lead?.Parent_Contact || "—"} />
                      <LeadField label="Renewal Date" value={lead?.Renewal_Date || "—"} />

                    </div>

                    {/* Right Column */}
                    <div className="space-y-3">
                      <LeadField label="PAN" value={lead?.PAN || "—"} />
                      <LeadField label="Marital Status" value={lead?.Marital_Status || "—"} />
                      <LeadField label="Donor Type" value={lead?.Donor_Type || "—"} />
                      {/* <LeadField label="Main Purpose" value={lead?.Main_Purpose1 || "—"} /> */}
                      <LeadField label="Donor Purpose" value={lead?.Purpose1 || "—"} />
                      <LeadField label="Total Donation Amount" value={lead?.Total_Transaction || "—"} />
                      <LeadField label="Contact Status" value={lead?.Contact_Status || "—"} />
                      <LeadField label="Date of Joining" value={lead?.Date_of_Joining || "—"} />
                      <LeadField label="Last Call Date" value={lead?.Last_Call_Date || "—"} />
                    </div>
                  </div>
                )}
              </div>


              <div className="lead-container2">
                <h3 className="lead-title">Donor Profiling</h3>
                <hr className="lead-divider" />
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">

                    {/* Left Column */}
                    <div className="space-y-3">
                      <LeadField label="Donor ID" value={lead?.Donor_Id || "—"} />
                      <LeadField label="Mobile No" value={lead?.Mobile_No || "—"} />
                      <LeadField label="Donor Location" value={lead?.Donor_Location || "—"} />
                      <LeadField label="Current Company" value={lead?.Current_Company || "—"} />
                      {/* <LeadField label="Last Donation Date" value={lead?.Last_Donation_Date || "—"} /> */}
                      <LeadField
                        label="Expected Donation Amount"
                        value={lead.Expected_Donation_Amount ? `₹${lead.Expected_Donation_Amount}` : "—"}
                      />
                      <LeadField
                        label="Call Dispositions"
                        value={lead?.Call_Status || "—"} // 👈 alias
                      />
                    </div>

                    {/* Right Column */}
                    <div className="space-y-3">
                      <LeadField
                        label="Existing Donor Name"
                        value={
                          lead?.Last_Name
                            ? `${lead?.Last_Name || ""}`.trim()
                            : "—"
                        }
                      />
                      <LeadField label="Email" value={<span className="email-value">{lead?.Email || "—"}</span>} />
                      <LeadField label="Age" value={lead?.Age || "—"} />
                      <LeadField label="Profession" value={lead?.Profession || "—"} />
                      <LeadField label="Birthday/Anniversary" value={lead?.Birthday_Anniversary || "—"} />
                      {/* <LeadField
                        label="Last Donation Amount"
                        value={lead.Last_Donation_Amount ? `₹${lead.Last_Donation_Amount}` : "—"}
                      /> */}
                      <LeadField
                        label="Contact Preferences"
                        value={
                          lead?.Contact_Preferences ? (
                            <span
                              className={`inline-block px-3 py-1 rounded-full text-xs font-medium w-fit text-white ${lead.Contact_Preferences === "Do Not Disturb"
                                ? "bg-red-500"
                                : lead.Contact_Preferences === "Call"
                                  ? "bg-yellow-400"
                                  : lead.Contact_Preferences === "WhatsApp"
                                    ? "bg-green-500"
                                    : lead.Contact_Preferences === "Email"
                                      ? "bg-sky-500"
                                      : "bg-gray-300"
                                }`}
                            >
                              {lead.Contact_Preferences}
                            </span>
                          ) : (
                            "—"
                          )
                        }
                      />
                      <LeadField label="Remarks" value={lead?.Remarks || "—"} />
                    </div>
                  </div>
                )}
              </div>







              {/* Address Information */}
              <div className="lead-container2">
                <h3 className="lead-title">Address Information</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">

                    {/* Left Column */}
                    <div className="space-y-3">
                      <LeadField label="Address" value={lead?.Address_1 || "—"} />
                      <LeadField label="Street" value={lead?.Street || "—"} />
                      <LeadField label="Country" value={lead?.Country || "—"} />


                    </div>

                    {/* Right Column */}
                    <div className="space-y-3">
                      <LeadField label="City Name" value={lead?.City_Name || "—"} />
                      <LeadField label="State Name" value={lead?.State_Name || "—"} />
                      <LeadField label="Pin" value={lead?.PIN || "—"} />


                    </div>

                  </div>
                )}
              </div>


              {/* Lead Generating Teams and Locations */}
              <div className="lead-container2">
                <h3 className="lead-title">Lead Generating Teams and Locations</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="RM Name" value={lead?.RM_Name || "—"} />
                      <LeadField label="Zones" value={lead?.Zones || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="RM Team" value={lead?.RM_Team || "—"} />
                      <LeadField label="Agency/ChannelPartner" value={lead?.Agency_ChannelPartner || "—"} />
                    </div>
                  </div>
                )}
              </div>

              {/* Bank Details */}
              {/* <div className="lead-container2">
                <h3 className="lead-title">Bank Details</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="Bank" value={lead?.Bank || "—"} />
                      <LeadField label="Deposited bank" value={lead?.Deposited_bank || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="Branch" value={lead?.Branch || "—"} />
                      <LeadField label="Deposited Slip No." value={lead?.Deposited_Slip_No || "—"} />
                      <LeadField label="Deposit Date" value={lead?.Deposit_Date || "—"} />
                    </div>
                  </div>
                )}
              </div> */}

              {/* WordPress Details */}
              {/* <div className="lead-container2">
                <h3 className="lead-title">WordPress Details</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="CCAvenue and Paytm Transaction Number" value={lead?.CCAvenue_and_Paytm_Transaction_Number || "—"} />
                      <LeadField label="Payment Transaction ID" value={lead?.Payment_Transaction_ID || "—"} />
                      <LeadField label="Donation Sub Purpose" value={lead?.Donation_Sub_Purpose || "—"} />
                      <LeadField label="Frequency of Donation" value={lead?.Frequency_of_Donation || "—"} />
                      <LeadField label="Payment Request" value={lead?.Payment_Request || "—"} />
                      <LeadField label="Payment Response" value={lead?.Payment_Response || "—"} />
                      <LeadField label="Citizenship" value={lead?.Citizenship || "—"} />
                      <LeadField label="UTM Source" value={lead?.UTM_Source || "—"} />
                      <LeadField label="UTM Medium" value={lead?.UTM_Medium || "—"} />
                      <LeadField label="IP Address" value={lead?.IP_Address || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="Billdesk Transactions" value={lead?.Billdesk_Transactions || "—"} />
                      <LeadField label="Type of Donation" value={lead?.Type_of_Donation || "—"} />
                      <LeadField label="Like to Sponsor" value={lead?.Like_to_Sponsor || "—"} />
                      <LeadField label="Duration of Support" value={lead?.Duration_of_Support || "—"} />
                      <LeadField label="Tax" value={lead?.Tax || "—"} />
                      <LeadField label="Transaction Status" value={lead?.Transaction_Status || "—"} />
                      <LeadField label="Newsletter" value={lead?.Newsletter || "—"} />
                      <LeadField label="Transactions Status" value={lead?.Transactions_Status || "—"} />
                      <LeadField label="Payment Status" value={lead?.Payment_Status || "—"} />
                      <LeadField label="Checksum" value={lead?.Checksum || "—"} />
                      <LeadField label="User Device" value={lead?.User_Device || "—"} />
                      <LeadField label="BRID" value={lead?.BRID || "—"} />
                    </div>
                  </div>
                )}
              </div> */}

              {/* Other Details */}
              <div className="lead-container2">
                <h3 className="lead-title">Other Details</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="No of Child Sponsor" value={lead?.No_of_Child_Sponsor || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="Sponsoring Child" value={lead?.Sponsoring_Child || "—"} />
                    </div>
                  </div>
                )}
              </div>

              {/* Remarks Section */}
              <div className="lead-container2">
                <h3 className="lead-title">Remarks Section</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="Remarks" value={lead?.Remarks || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="birthday and Current day match" value={lead?.birthday_and_Current_day_match || "—"} />
                      <LeadField label="Birthday Month and Day" value={lead?.Birthday_Moth_and_Day || "—"} />
                    </div>
                  </div>
                )}
              </div>

              {/* Visit Summary */}
              <div className="lead-container2">
                <h3 className="lead-title">Visit Summary</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    <div className="space-y-3">
                      <LeadField label="Most Recent Visit" value={lead?.Last_Visited_Time || "—"} />
                      <LeadField label="Average Time Spent (Minutes)" value={lead?.Average_Time_Spent_Minutes || "—"} />
                      <LeadField label="Referrer" value={lead?.Referrer || "—"} />
                      <LeadField label="First Visit" value={lead?.First_Visited_Time || "—"} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="First Page Visited" value={lead?.First_Visited_URL || "—"} />
                      <LeadField label="Number Of Chats" value={lead?.Number_Of_Chats || "—"} />
                      <LeadField label="Visitor Score" value={lead?.Visitor_Score || "—"} />
                      <LeadField label="Days Visited" value={lead?.Days_Visited || "—"} />
                    </div>
                  </div>
                )}
              </div>








              <div id="notes" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Notes</h3>

                {notesData.length > 0 && (
                  <PaginatedList data={notesData}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange,
                    }) => (
                      <>
                        {/* Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">Note</th>
                                <th className="py-2 px-3">Potential Donor</th>
                                <th className="py-2 px-3">Time</th>
                                {/* <th className="py-2 px-3">Owner</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((note, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">{note.Note_Content || "—"}</td>
                                  <td className="py-2 px-3">{note.Parent_Id?.name || "—"}</td>
                                  <td className="py-2 px-3">now</td>
                                  {/* <td className="py-2 px-3">{note.Owner?.name || "—"}</td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination controls */}
                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          {/* Entry range info */}
                          <div>
                            Showing {startEntry} to {endEntry} of {totalRecords} Entries
                          </div>

                          {/* Page size selector */}
                          <div className="flex items-center gap-2">
                            <label htmlFor="notesPageSize">Records per list:</label>
                            <select
                              id="notesPageSize"
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          {/* Pagination buttons */}
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>)}
              </div>










              <div id="attach" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Attachments</h3>

                {attachments.length > 0 && (
                  <PaginatedList data={attachments}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange,
                    }) => (
                      <>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">File Name</th>
                                {/* <th className="py-2 px-3">Attached By</th> */}
                                <th className="py-2 px-3">Date Added</th>
                                <th className="py-2 px-3">Size</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((att, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">
                                    {att.File_Name ? (
                                      <a
                                        href="#"
                                        className="text-blue-600 underline cursor-pointer"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          // handleDownload(att.id);
                                        }}
                                      >
                                        {att.File_Name}
                                      </a>
                                    ) : "—"}
                                  </td>
                                  {/* <td className="py-2 px-3">{att.Owner?.name || "—"}</td> */}
                                  <td className="py-2 px-3">{att.Created_Time ? formatDate(att.Created_Time) : "—"}</td>
                                  <td className="py-2 px-3">{formatSize(att.Size)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          <div>Showing {startEntry} to {endEntry} of {totalRecords} Entries</div>

                          <div className="flex items-center gap-2">
                            <label htmlFor="attachPageSize">Records per list:</label>
                            <select
                              id="attachPageSize"
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>

                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>
                )}
              </div>



              <div id="email" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Emails</h3>

                {sortedEmails.length > 0 && (<PaginatedList data={sortedEmails}>
                  {({
                    data,
                    currentPage,
                    totalPages,
                    totalRecords,
                    startEntry,
                    endEntry,
                    recordsPerPage,
                    handleChangePage,
                    handlePageSizeChange,
                  }) => (
                    <>
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b bg-gray-50 text-left">
                              <th className="py-2 px-3">Subject</th>
                              <th
                                className="py-2 px-3 cursor-pointer select-none"
                                onClick={() => requestEmailSort("time")}
                                onMouseEnter={() => setEmailHoveredCol("time")}
                                onMouseLeave={() => setEmailHoveredCol(null)}
                              >
                                <span className="flex items-center gap-1">
                                  Date
                                  <span className="text-xs">
                                    {emailHoveredCol === "time" && emailSortConfig.key !== "time" && (
                                      <span className="text-gray-400">▲▼</span>
                                    )}
                                    {emailSortConfig.key === "time" &&
                                      (emailSortConfig.direction === "asc" ? "▲" : "▼")}
                                  </span>
                                </span>
                              </th>

                              <th className="py-2 px-3">Source</th>
                              {/* <th className="py-2 px-3">Sent By</th> */}
                              <th className="py-2 px-3">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((email, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="py-2 px-3">{email.subject || "—"}</td>
                                <td className="py-2 px-3">{email.time ? formatDate(email.time) : "—"}</td>
                                <td className="py-2 px-3">{email.Source || "—"}</td>
                                {/* <td className="py-2 px-3">{email.from?.user_name || "—"}</td> */}
                                <td className="py-2 px-3">{email.status?.[0]?.type || "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                        <div>
                          Showing {startEntry} to {endEntry} of {totalRecords} Entries
                        </div>

                        <div className="flex items-center gap-2">
                          <label htmlFor="emailPageSize">Records per list:</label>
                          <select
                            id="emailPageSize"
                            value={recordsPerPage}
                            onChange={handlePageSizeChange}
                            className="border px-2 py-1 rounded"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                          </select>
                        </div>

                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleChangePage(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Prev
                          </button>

                          <button
                            onClick={() => handleChangePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </PaginatedList>
                )}
              </div>


              <div id="call" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Manual Call</h3>

                {sortedCalls.length > 0 && (
                  <PaginatedList data={sortedCalls}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange
                    }) => (
                      <>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">Donor Name</th>

                                {/* Created Time */}
                                <th
                                  className="py-2 px-3 cursor-pointer select-none"
                                  onClick={() => requestSort("Created_Time")}
                                >
                                  <span className="flex items-center gap-1">
                                    Created Time
                                    {/* <span className="text-xs">
                                      {sortConfig.key === "Created_Time" &&
                                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                                    </span> */}
                                  </span>
                                </th>

                                <th className="py-2 px-3">Call Disposition</th>
                                <th className="py-2 px-3">Remarks</th>
                                <th className="py-2 px-3">Donation Purpose</th>

                                {/* Reschedule Time */}
                                <th
                                  className="py-2 px-3 cursor-pointer select-none"
                                  onClick={() => requestSort("Reschedule_Time")}
                                >
                                  <span className="flex items-center gap-1">
                                    Reschedule Time
                                    {/* <span className="text-xs">
                                      {sortConfig.key === "Reschedule_Time" &&
                                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                                    </span> */}
                                  </span>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {data.map((call, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">
                                    {call.Name ? (
                                      <a
                                        href={`/app/call-details/${call.id}`}
                                        className="text-blue-600 hover:underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {call.Name}
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="py-2 px-3">
                                    {call.Created_Time
                                      ? new Date(call.Created_Time).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                      })
                                      : "-"}
                                  </td>

                                  <td className="py-2 px-3">{call.Call_Status || "-"}</td>
                                  <td className="py-2 px-3">{call.Remarks || "-"}</td>
                                  <td className="py-2 px-3">{call.Purpose1 || "-"}</td>

                                  <td className="py-2 px-3">
                                    {call.Reschedule_Time
                                      ? new Date(call.Reschedule_Time).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                      })
                                      : "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          <div>
                            Showing {startEntry} to {endEntry} of {totalRecords} entries
                          </div>

                          <div className="flex items-center gap-2">
                            <label>Records per list:</label>
                            <select
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>
                )}
              </div>




              <div id="payment" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Payments</h3>

                {sortedPayments.length > 0 && (
                  <PaginatedList data={sortedPayments}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange
                    }) => (
                      <>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">Zoho Payments ID</th>
                                <th className="py-2 px-3">Payment Status</th>
                                <th className="py-2 px-3">Billing Phone</th>
                                <th className="py-2 px-3">Amount</th>

                                {/* Transaction Date Sort */}
                                <th
                                  className="py-2 px-3 cursor-pointer select-none"
                                  onClick={() => requestPaymentSort("Transaction_Date")}
                                >
                                  <span className="flex items-center gap-1">
                                    Transaction Date
                                    <span className="text-xs">
                                      {paymentSortConfig.key === "Transaction_Date" &&
                                        (paymentSortConfig.direction === "asc" ? "▲" : "▼")}
                                    </span>
                                  </span>
                                </th>

                                <th className="py-2 px-3">Donation Frequency</th>
                                <th className="py-2 px-3">Payment Mode</th>
                                <th className="py-2 px-3">Created Time</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data.map((payment, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">
                                    {payment.Name ? (
                                      <a
                                        href={`/app/payment-details/${payment.id}`}
                                        className="text-blue-600 hover:underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {payment.Name}
                                      </a>
                                    ) : (
                                      "—"
                                    )}
                                  </td>
                                  <td className="py-2 px-3">{payment.Order_Status || ""}</td>
                                  <td className="py-2 px-3">{payment.Billing_Phone || ""}</td>
                                  <td className="py-2 px-3">₹{payment.Amount?.toLocaleString() || ""}</td>
                                  <td className="py-2 px-3">
                                    {payment.Transaction_Date
                                      ? parseCustomDate(payment.Transaction_Date).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                                      : ""}
                                  </td>
                                  <td className="py-2 px-3">{payment.Payment_Frequency || ""}</td>
                                  <td className="py-2 px-3">{payment.Payment_Gateway || ""}</td>
                                  <td className="py-2 px-3">
                                    {payment.Created_Time
                                      ? parseCustomDate(payment.Created_Time).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                                      : ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          <div>
                            Showing {startEntry} to {endEntry} of {totalRecords} entries
                          </div>

                          <div className="flex items-center gap-2">
                            <label htmlFor="paymentPageSize">Records per list:</label>
                            <select
                              id="paymentPageSize"
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>
                )}
              </div>


              <div id="profiling" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Donor Profiling</h3>

                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border-collapse table-fixed">
                    <thead>
                      <tr className="border-b bg-gray-50 text-left">
                        {[
                          { key: "Name", label: "Full Name" },
                          { key: "Disposition1", label: "Disposition1" },
                          { key: "Contact_Preferences", label: "Contact Preferences" },
                          { key: "Phone", label: "Phone" },
                          { key: "Email", label: "Email" },
                          { key: "Birthday_Anniversary", label: "Birthday Anniversary" },
                          { key: "Last_Call_Date", label: "Last Call Date" },
                          // { key: "Last_Donation_Date", label: "Last Donation Date" },
                          { key: "Expected_Donation_Amount", label: "Expected Donation Amount" },
                          // { key: "Last_Donation_Amount", label: "Last Donation Amount" },
                          { key: "Current_Company", label: "Current Company" },
                          { key: "Age", label: "Age" },
                          { key: "Location", label: "Location" },
                          { key: "Profession", label: "Profession" },
                          { key: "Remarks", label: "Remarks" },
                        ]
                          .filter(col =>
                            statusData.some(item => item[col.key] && item[col.key] !== "")
                          )
                          .map(col => (
                            <th key={col.key} className="py-2 px-3">{col.label}</th>
                          ))}
                      </tr>
                    </thead>

                    <tbody>
                      {statusData.map((item, index) => (
                        <tr key={index} className="border-t">
                          {[
                            { key: "Name" },
                            { key: "Disposition1" },
                            { key: "Contact_Preferences" },
                            { key: "Phone" },
                            { key: "Email" },
                            { key: "Birthday_Anniversary" },
                            { key: "Last_Call_Date" },
                            // { key: "Last_Donation_Date" },
                            { key: "Expected_Donation_Amount", prefix: "₹" },
                            // { key: "Last_Donation_Amount", prefix: "₹" },
                            { key: "Current_Company" },
                            { key: "Age" },
                            { key: "Location" },
                            { key: "Profession" },
                            { key: "Remarks" },
                          ]
                            .filter(col =>
                              statusData.some(row => row[col.key] && row[col.key] !== "")
                            )
                            .map(col => (
                              <td key={col.key} className="py-2 px-3 whitespace-nowrap">
                                {col.prefix ? `${col.prefix}${item[col.key] || ""}` : item[col.key] || ""}
                              </td>
                            ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>


              <div id="sponsor-child" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Sponsor Child</h3>

                {sponsorData.length > 0 && (
                  <PaginatedList data={sponsorData}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange
                    }) => (
                      <>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">Name</th>

                                <th className="py-2 px-3">Date of Birth</th>

                                <th className="py-2 px-3">SI No</th>

                                <th className="py-2 px-3">SC Number</th>

                                {/* <th className="py-2 px-3">Last Donation Date</th> */}

                                {/* <th className="py-2 px-3">Last Donation Amount</th> */}

                                {/* <th
                                  className="py-2 px-3 cursor-pointer select-none"
                                  onClick={() => requestSort("Created_Time")}
                                >
                                  <span className="flex items-center gap-1">
                                    Created Time
                                  </span>
                                </th> */}
                              </tr>
                            </thead>

                            <tbody>
                              {data.map((child, idx) => (
                                <tr key={idx} className="border-t">
                                  {/* Name */}
                                  <td className="py-2 px-3">
                                    {child.Name || "-"}
                                  </td>

                                  {/* Date of Birth */}
                                  <td className="py-2 px-3">
                                    {child.Date_Of_Birth
                                      ? new Date(child.Date_Of_Birth).toLocaleDateString("en-IN")
                                      : "-"}
                                  </td>

                                  {/* SI No */}
                                  <td className="py-2 px-3">
                                    {child.SI_No || "-"}
                                  </td>

                                  {/* SC Number */}
                                  <td className="py-2 px-3">
                                    {child.SC_Number || "-"}
                                  </td>

                                  {/* Last Donation Date */}
                                  {/* <td className="py-2 px-3">
                                    {child.Last_Donation_Date
                                      ? new Date(child.Last_Donation_Date).toLocaleDateString("en-IN")
                                      : "-"}
                                  </td> */}

                                  {/* Last Donation Amount */}
                                  {/* <td className="py-2 px-3">
                                    {child.Last_Donation_Amount ?? "-"}
                                  </td> */}

                                  {/* Created Time */}
                                  {/* <td className="py-2 px-3">
                                    {child.Created_Time
                                      ? new Date(child.Created_Time).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                      })
                                      : "-"}
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          <div>
                            Showing {startEntry} to {endEntry} of {totalRecords} entries
                          </div>

                          <div className="flex items-center gap-2">
                            <label>Records per list:</label>
                            <select
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>
                )}
              </div>













              {showModal && (
                <SendEmailFormatSecond
                  idToFetch={lead?.id}
                  lead={lead}
                  firstName={lead?.First_Name}
                  lastName={lead?.Last_Name}
                  onEmailSent={fetchEmails} // ✅ pass function here
                  onClose={() => setShowModal(false)}
                />
              )}

              {showSuccessModal && (
                <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
                  <div className="bg-white p-8 rounded-[20px] shadow-xl text-center max-w-sm w-full">

                    {/* Title with Check Emoji */}
                    <h2 className="text-2xl font-bold" style={{ color: "#14446D" }}>
                      ✅ Success!
                    </h2>

                    {/* Message */}
                    <p className="mt-3 text-gray-600">
                      Call log has been created successfully.
                    </p>

                    {/* Close Button */}
                    <button
                      onClick={() => setShowSuccessModal(false)}
                      className="mt-5 px-5 py-2 text-white rounded-lg hover:brightness-110 transition"
                      style={{ backgroundColor: "#2070B9" }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}









            </div>
          </main>

        </div >
      </React.Fragment >
    )


  );
};

export default OrderDetail;
